export default {
        comments: {
            title : "Comments",
            inputLabel : "Insert here a comment",
            actionlabel : "Publish",
            cancel :"Cancel",
            save : "Save"
        },
        chatbot: {
            errorMessage: "An error occured sending the message",
            tryAgain: "Try again",
            suggestedAnswers : "Suggested answers",
            inputPlaceHolder : "Enter here a message",
            restartMessage : "Conversation is restarting"
        },
        facets : {
            showAll : "Show all",
            showLess : "Show less"
        },
        notifications : {
            days : "days",
            hours : "hours",
            minutes : "min",
            seconds : "s"
        },
        commands : {
            globalPlaceholder : "Type / to show all available commands",
            executeCommand : "Press Enter to execute command",
            linkLabel : "Show details"
        },
		"uploader" : {
			"clear_all" : "Clear All",
			"removeUploaded" : "Remove Uploaded Files",
			"remove" : "Remove",
			"add" : "Pick Files",
			"upload" : "Upload Files",
			"clear" : "Abort Upload"
		},
        handles : {
            placeholder : "Enter a handle : format is type/code"
        }
    };